import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastType } from '@sphereon/ui-components.core';
import SSICheckmarkBadge from '../../../assets/badges/SSICheckmarkBadge';
import SSIExclamationMarkBadge from '../../../assets/badges/SSIExclamationMarkBadge';
import { SSIToastContainerStyled as Container, SSIToastMessageTextStyled as MessageText, SSIFlexDirectionRowViewStyled as MessageContainer, SSITextH2SemiBoldStyled as TitleText, SSIToastTitleContainerStyled as TitleContainer, SSIToastBadgeContainerStyled as ToastBadgeContainer, } from '../../../../styles';
const getBadge = (type) => {
    switch (type) {
        case ToastType.SUCCESS:
            return _jsx(SSICheckmarkBadge, {});
        case ToastType.ERROR:
            return _jsx(SSIExclamationMarkBadge, {});
        default:
            return _jsx("div", {});
    }
};
const SSIToast = (props) => {
    const { type, title, message, showBadge = true, onClick } = props;
    return (_jsxs(Container, { onClick: onClick, children: [title && (_jsxs(TitleContainer, { children: [showBadge && _jsx(ToastBadgeContainer, { children: getBadge(type) }), _jsx(TitleText, { children: title })] })), _jsxs(MessageContainer, { children: [!title && showBadge && _jsx(ToastBadgeContainer, { children: getBadge(type) }), message && _jsx(MessageText, { style: { ...(showBadge && { textAlign: 'center' }) }, children: message })] })] }));
};
export default SSIToast;
